import React, { useEffect, useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import FormContainer from "./FormContainer";
import LoadingButton from "../../../components/LoadingButton";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { Switch } from "@material-ui/core";

export default ({ packageForInspectionSubjects }) => {
  const [subjects, setSubjects] = useState(packageForInspectionSubjects);
  const [dirty, setDirty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    setSubjects(packageForInspectionSubjects);
  }, [packageForInspectionSubjects]);

  const handleChange = (event) => {
    // Remove always:
    setSubjects((subjects) => {
      const newSubjects = subjects.map((subject) => {
        if (subject.uuid == event.target.name) {
          return { ...subject, enabled: !subject.enabled };
        }
        return subject;
      });
      return newSubjects;
    });
    setDirty(true);
  };

  const onCancelPackagePreview = (e) => {
    e.preventDefault();
    setIsLoading(true);

    fetch("/sections/my-account/ajax/cancel_package_for_inspection.php", {
      method: "POST",
      body: JSON.stringify({
        subjects: subjects,
      }),
    })
      .then((r) => {
        console.log("Result", r);
        setDirty(false);
        return r.json();
      })
      .then((json) => {
        if (!json.error) {
          setSubjects(json.subjects);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <FormContainer>
      <h4>
        <Trans>Cancel picture packages</Trans>
      </h4>
      <p>
        <Trans>
          You will receive a standard picture package for each of these for
          inspection.
        </Trans>
      </p>
      <p>
        <Trans>
          If you don't want packages for inspection please switch off and click
          'Cancel picture packages'.
        </Trans>
      </p>

      <FormGroup column>
        {subjects.map((subject) => {
          return (
            <FormControlLabel
              key={subject.uuid}
              control={
                <Switch
                  onChange={handleChange}
                  name={subject.uuid}
                  checked={!!subject.enabled}
                />
              }
              label={subject.name}
            />
          );
        })}
      </FormGroup>

      <LoadingButton
        type="button"
        onClick={onCancelPackagePreview}
        isLoading={isLoading}
        disabled={!dirty}
        style={{ marginTop: "20px" }}
        fullWidth
      >
        <Trans>Cancel picture packages</Trans>
      </LoadingButton>
    </FormContainer>
  );
};
